<template>
  <div class="">
    <v-tooltip
      top
      :disabled="!content">
      <template
        v-slot:activator="{ on, attrs }">
        <div
          :class="`d-flex flex-column cellContent ${cellClass}`"
          v-bind="attrs"
          v-on="on"
          v-if="content">
          <span
            class="cellLine"
            :style="cellStyle">
            {{ content }}
          </span>
        </div>
      </template>

      <span>
        {{ content }}
      </span>
    </v-tooltip>

  </div>
</template>

<script>
export default {
  name: 'Cell',

  props: {
    content: { required: true },
    cellClass: { type: String, default: '' },
    cellStyle: { type: String, default: '' },
  }
}
</script>

<style scoped>
.cellContent {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cellLine {
  min-height: 14px; 
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}
</style>
